import { createFileRoute, Link } from "@tanstack/react-router";
import { Phone, Home, Check } from "lucide-react";
import { CallLink } from "@/components/landing/CallLink";
import { useEffect } from "react";

export const Route = createFileRoute("/thank-you")({
  head: () => ({
    meta: [
      { title: "Thank You — Tata Play DTH New Connection | Nearby Services" },
      { name: "description", content: "Thank you for booking your Tata Play DTH new connection. Our team will call you back shortly. For urgent queries, call or WhatsApp 6364894003." },
      { property: "og:title", content: "Thank You — Tata Play DTH New Connection" },
      { property: "og:description", content: "Your callback request has been received. Our team will reach out shortly." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://nearbyservices.co.in/thank-you" },
      { name: "robots", content: "noindex" },
    ],
    links: [{ rel: "canonical", href: "https://nearbyservices.co.in/thank-you" }],
    scripts: [
      {
        type: "text/javascript",
        children: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-N79KP5PW');`,
      },
    ],
  }),
  component: ThankYouPage,
});

function ThankYouPage() {
  useEffect(() => {
    const w = window as unknown as { dataLayer?: unknown[] };
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({
      event: "lead_thank_you",
      page_path: "/thank-you",
      page_title: "Thank You — Tata Play DTH New Connection",
      page_location: window.location.href,
    });
    w.dataLayer.push({
      event: "virtual_page_view",
      page_path: "/thank-you",
      page_location: window.location.href,
    });
  }, []);

  return (
    <>
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-N79KP5PW"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        />
      </noscript>
      <div className="flex min-h-screen items-center justify-center bg-page-tint p-4 text-foreground">
        <div className="w-full max-w-md rounded-[2rem] bg-card p-8 text-center shadow-[var(--shadow-elevated)] sm:p-10">
        <div className="mx-auto grid h-[4.5rem] w-[4.5rem] place-items-center rounded-2xl bg-success-soft text-success">
          <Check className="h-9 w-9 stroke-[3]" />
        </div>

        <h1 className="mt-7 text-4xl font-extrabold text-accent sm:text-[2.75rem]">Thank You!</h1>
        <p className="mt-4 text-base leading-relaxed text-muted-foreground">
          Your Tata Play DTH New Connection request has been received. Our team will call you shortly to confirm your plan and installation slot.
        </p>

        <div className="mt-6 rounded-2xl bg-neutral-soft px-5 py-4 text-sm leading-relaxed text-muted-foreground">
          Same-day installation · Cash on delivery · Pay after installation
        </div>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:gap-4">
          <CallLink
            location="thank_you_page"
            label="Thank You Call"
            className="inline-flex flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-full bg-[image:var(--gradient-cta)] px-6 py-3.5 text-base font-semibold text-white shadow-lg transition hover:brightness-110"
          >
            <Phone className="h-5 w-5" />
            Call 6364894003
          </CallLink>
          <Link
            to="/"
            className="inline-flex flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-full border border-border bg-card px-6 py-3.5 text-base font-semibold text-foreground shadow-sm transition hover:bg-secondary"
          >
            <Home className="h-5 w-5" />
            Back to Home
          </Link>
        </div>
      </div>
    </div>
    </>
  );
}
